'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    $(document).on($.modal.OPEN, '.modal--jcarousel', (_, modal) => {
      const num = $(modal.elm).data('num');
      if (typeof num !== 'undefined') {
        const connector = function (itemNavigation, carouselStage) {
          return carouselStage.jcarousel('items').eq(itemNavigation.index());
        };

        const carouselStage = $('.modal--jcarousel__carousel--stage').jcarousel();
        const carouselNavigation = $('.modal--jcarousel__carousel--navigation').jcarousel();

        // we loop through the items of the navigation carousel and set it up
        // as a control for an item from the stage carousel
        carouselNavigation.jcarousel('items').each(function () {
          const $item = $(this);

          // this is where we actually connect to items
          const target = connector($item, carouselStage);

          $item
            .on('jcarouselcontrol:active', function () {
              carouselNavigation.jcarousel('scrollIntoView', this);
              $item.find('img').addClass('modal--jcarousel__navigation-image--active');
            })
            .on('jcarouselcontrol:inactive', function () {
              $item.find('img').removeClass('modal--jcarousel__navigation-image--active');
            })
            .jcarouselControl({
              target,
              carousel: carouselStage,
            });
        });

        // scroll to appropriate image
        $('.modal--jcarousel__carousel--stage').jcarousel('scroll', num, false);

        // setup controls for the stage carousel
        $('.modal--jcarousel .pagination-link--prev')
          .on('jcarouselcontrol:inactive', function () {
            $(this).addClass('pagination-link--disabled');
          })
          .on('jcarouselcontrol:active', function () {
            $(this).removeClass('pagination-link--disabled');
          })
          .jcarouselControl({
            target: '-=1',
          });

        $('.modal--jcarousel .pagination-link--next')
          .on('jcarouselcontrol:inactive', function () {
            $(this).addClass('pagination-link--disabled');
          })
          .on('jcarouselcontrol:active', function () {
            $(this).removeClass('pagination-link--disabled');
          })
          .jcarouselControl({
            target: '+=1',
          });

        // setup controls for the navigation carousel
        $('.modal--jcarousel__navigation-control--prev')
          .on('jcarouselcontrol:inactive', function () {
            $(this).addClass('modal--jcarousel__navigation-control--inactive');
          })
          .on('jcarouselcontrol:active', function () {
            $(this).removeClass('modal--jcarousel__navigation-control--inactive');
          })
          .jcarouselControl({
            target: '-=1',
          });

        $('.modal--jcarousel__navigation-control--next')
          .on('jcarouselcontrol:inactive', function () {
            $(this).addClass('modal--jcarousel__navigation-control--inactive');
          })
          .on('jcarouselcontrol:active', function () {
            $(this).removeClass('modal--jcarousel__navigation-control--inactive');
          })
          .jcarouselControl({
            target: '+=1',
          });
      }
    });

    $(document).on($.modal.CLOSE, '.modal--jcarousel', (_, modal) => {
      modal.elm.remove();
    });
  });
});
